import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
import './app/theme/globals.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

/*
 * Installable as an app, and opens offline to the last copy of the shell.
 * Only the built application registers it; development never caches.
 *
 * A worker that has already been installed keeps serving the copy of the app
 * it was installed with, so a release could go out and the people using it
 * would carry on with the old one — refreshing, being told the change was
 * live, and seeing no change. So the registration asks for an update as soon
 * as it is made and whenever the tab is brought back to the front, and when a
 * new worker takes over, the page is reloaded once onto it.
 */
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      reg.update().catch(() => {});
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') reg.update().catch(() => {});
      });
    }).catch(() => { /* the app works without it */ });

    let reloading = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloading) return;
      reloading = true;
      window.location.reload();
    });
  });
}
